import React, { useState } from "react";

import {
  Button,
  TextField,
  Menu,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Icon,
  AppBar,
  Tabs,
  Tab,
  Link,
} from "@mui/material";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import DataTable from "customComponents/Tables/DataTable";

import PropTypes from "prop-types";
import { formatDate, formatTimeSpent } from "../../../../utils";
import { deviceLocation, deviceState, deviceType } from "../../../../enums";

import { JIRA_API_URL } from "../../../../config";

function AttendenceDialog({ open, data, onClose }) {
  const { name, date, attendances, worklogs } = data;

  const [tabValue, setTabValue] = useState(0);
  const handleSetTabValue = (event, newValue) => setTabValue(newValue);

  const columns = [
    { Header: "recordTime", accessor: "recordTime", align: "center" },
    { Header: "state", accessor: "state", align: "center" },
    { Header: "location", accessor: "location", align: "center" },
    { Header: "type", accessor: "type", align: "center" },
  ];

  const worklogColumns = [
    { Header: "Issue", accessor: "issue", align: "left" },
    { Header: "Record time", accessor: "recordTime", align: "center" },
    { Header: "Logged", accessor: "timeSpent", align: "center" },
    // { Header: "Created At", accessor: "createdAt", align: "center" },
  ];

  const rows = attendances.map((attendance) => {
    const { recordTime, device, id } = attendance;

    return {
      recordTime: (
        <MDTypography variant="caption" fontWeight="medium">
          {formatDate(recordTime)}
        </MDTypography>
      ),
      state: (
        <MDTypography variant="caption" fontWeight="medium">
          {deviceState.value(device?.state)}
        </MDTypography>
      ),
      location: (
        <MDTypography variant="caption" fontWeight="medium">
          {deviceLocation.value(device?.location)}
        </MDTypography>
      ),
      type: (
        <MDTypography variant="caption" fontWeight="medium">
          {deviceType.value(device?.type)}
        </MDTypography>
      ),
    };
  });

  const worklogRows = worklogs
    ? worklogs.map((worklog) => {
        const {
          issueIdOrKey,
          issueSummary,
          projectName,
          timeSpentSeconds,
          worklogCreated,
          worklogStarted,
        } = worklog;

        return {
          issue: (
            <Link href={`${JIRA_API_URL}/browse/${issueIdOrKey}`} target="_blank">
              <MDBox
                display="flex"
                alignItems="left"
                flexDirection="column"
                lineHeight={1}
                sx={{ maxWidth: "240px" }}
              >
                {/* <MDBox lineHeight={1} ml={0}> */}

                <MDTypography
                  variant="caption"
                  fontWeight="medium"
                  // color="text"
                  noWrap={false}
                  sx={{ wordBreak: "break-word" }}
                >
                  {`${issueIdOrKey}:${issueSummary}`}
                </MDTypography>

                <MDTypography variant="caption">{projectName}</MDTypography>
              </MDBox>
            </Link>
          ),
          recordTime: (
            <MDTypography variant="caption" fontWeight="medium">
              {formatDate(worklogStarted)}
            </MDTypography>
          ),
          timeSpent: (
            <MDTypography variant="caption" fontWeight="medium">
              {formatTimeSpent(timeSpentSeconds)}
            </MDTypography>
          ),
          createdAt: (
            <MDTypography variant="caption" fontWeight="medium">
              {formatDate(worklogCreated)}
            </MDTypography>
          ),
        };
      })
    : [];

  const handleClose = () => {
    onClose && onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        <MDBox display="flex" flexDirection="column" flex={1} alignItems="center">
          <MDTypography variant="block">{name}</MDTypography>
          <MDTypography variant="caption" color="text">
            {formatDate(date, "ll")}
          </MDTypography>
        </MDBox>
      </DialogTitle>
      <DialogContent>
        {worklogRows.length > 0 && (
          <AppBar position="static">
            <Tabs orientation={"horizontal"} value={tabValue} onChange={handleSetTabValue}>
              <Tab
                label="Thumbs"
                icon={
                  <Icon fontSize="small" sx={{ mt: -0.25 }}>
                    fingerprint
                  </Icon>
                }
              />
              <Tab
                label="Jira Logs"
                icon={
                  <Icon fontSize="small" sx={{ mt: -0.25 }}>
                    devices
                  </Icon>
                }
              />
            </Tabs>
          </AppBar>
        )}

        {tabValue === 0 ? (
          <DataTable
            table={{ rows, columns }}
            showTotalEntries={true}
            isSorted={false}
            noEndBorder
            entriesPerPage={false}
          />
        ) : (
          <DataTable
            table={{ rows: worklogRows, columns: worklogColumns }}
            showTotalEntries={true}
            isSorted={false}
            noEndBorder
            entriesPerPage={false}
          />
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}

// Setting default values for the props of DataTable
AttendenceDialog.defaultProps = {
  open: false,
  data: {},
  onClose: null,
};

// Typechecking props for the DataTable
AttendenceDialog.propTypes = {
  open: PropTypes.bool,
  data: PropTypes.object,
  onClose: PropTypes.func,
};

export default AttendenceDialog;
